// import { forEach } from "core-js/core/array";

document.addEventListener("DOMContentLoaded", (event) => {
    console.log("DOM fully loaded and parsed");

    const body = document.body;

    /* Burger Menu open / close */
    let burgerbutton = document.getElementById("toggle-burger");
    let burgermenu = document.getElementById("wp-nav-wrapper");
    
    burgerbutton.addEventListener("click", ()=>{
        burgermenu.classList.toggle("open-bm");
        body.classList.toggle("menu-open");
    })


    /* Dropdown in Burger Menu */
    const dropdownmenus = Array.from(document.getElementsByClassName("menu-item-has-children"));

    function removeOpen() {
        dropdownmenus.forEach(dropdownmenu => {
            dropdownmenu.classList.remove("open");
        });
    }

    /* Dropdown öffnet wenn "clicked", führt function aus die wiederum andere Submenus schließt */
    dropdownmenus.forEach(dropdownmenu => {
        
        dropdownmenu.addEventListener("click", ()=>{
            if (dropdownmenu.classList.contains("open")) {
                removeOpen();
            } else {
                removeOpen();
                dropdownmenu.classList.add("open");
            }
        }) 
    });


    //replace all Wordpress links with href="#"
    let links = Array.from(document.getElementsByTagName('a'));

    function turnUnusedLinktoDiv( linkParent){
        var d = document.createElement('div');
        d.innerHTML = linkParent.firstChild.innerHTML;
        d.classList.add("none-clickable");

        linkParent.replaceChild(d, linkParent.firstChild);
    }

    links.forEach(link => {
        let url = link.getAttribute("href");
        if(url == '#'){
            let parent = link.parentElement
            turnUnusedLinktoDiv(parent);
        }
    });


    //close menu on outer click
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.menu-item')){
            removeOpen();
        }  
    })





    //login

    let loginButtons = Array.from(document.getElementsByClassName('login'));
    const loginForm = document.getElementById('loginform-container');
    const closeFormButton = document.getElementById('close-loginform');

    loginButtons.forEach(button => {
        button.addEventListener('click', ()=>{
            loginForm.classList.toggle('display');
        });
    });

    function closeForm(){
        loginForm.classList.remove('display');
    }

    closeFormButton.addEventListener('click', ()=>{
        closeForm();
        burgermenu.classList.remove("open-bm");
        body.classList.remove("menu-open");
    });

    window.addEventListener('click',function(event){
        if(
            !event.target.classList.contains('login')
            && !event.target.classList.contains('toggle-login')
            && !event.target.closest('.toggle-login')
            && loginForm.classList.contains('display')
        ){
            closeForm(); 
        }
    });  

    loginForm.addEventListener('click', (event)=>{
        event.stopPropagation();
    });


    //on wrong PW, let lofin open
    const response = document.getElementById('response');

    if(response){
        loginForm.classList.add('display');
    }



    //mobile search
    const mobileSearchButton = document.getElementById('search-mobile');
    const searchOverlay = document.getElementById('search-ov');

    mobileSearchButton.addEventListener('click', ()=>{
        searchOverlay.classList.add('active');
        body.classList.add("menu-open");
    });  

    //close search-ov on outer click

    searchOverlay.addEventListener('click',function(event){
       
        if(
            !event.target.classList.contains('search-field')
            && !event.target.classList.contains('search-submit')
        ){
            searchOverlay.classList.remove('active');
            body.classList.remove("menu-open");
        }
        
    });  

    const menuMain = document.getElementById('menu-main');

    var link = document.createElement('a');
    link.href = "/fuer-kunden";
    link.innerText = "Für Kunden";
    link.classList.add('menu-customer');
    var li = document.createElement('li');
    li.appendChild(link);
    menuMain.appendChild(li);



});